"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _cuid = _interopRequireDefault(require("cuid"));

var getUniqueId = function getUniqueId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "zomato";
  return prefix.toLowerCase() + "_" + (0, _cuid["default"])();
};

var _default = getUniqueId;
exports["default"] = _default;